/**
 * パネルのレイアウト設定を取得する関数
 * @param isPaidPlan 有料プランフラグ（紹介特典/Stripe含む）
 * @param referralActive 紹介特典が有効か
 */
export const getPanelLayouts = (isPaidPlan: boolean, referralActive: boolean = false) => ({
    /**
     * PCレイアウト
     * 最大カラム数１２
     */
    pc: [
        /**
         * デスク画面
         */
        { i: 'hmActivityCalendar', x: 0, y: 1, w: 6, h: 3, minW: 2, minH: 3 },
        { i: 'hmTimeClock', x: 6, y: 1, w: 3, h: 3, minW: 3, minH: 2 },
        { i: 'hmTimeProgress', x: 6, y: 0, w: 12, h: 1, minW: 2, minH: 1 },
        {
            i: 'hmSimpleAnalytics',
            x: 0,
            y: 4,
            w: 6,
            h: 3,
            minW: 3,
            minH: 3,
            // 無料プラン以外はサイズ上限なし
            maxH: isPaidPlan ? undefined : 3,
            maxW: isPaidPlan ? undefined : 6,
        },
        { i: 'hmMemo', x: 0, y: 7, w: 6, h: 3, minW: 3, minH: 2 },
        // サブスク課金以外は表示
        // 紹介パネルは無料プランと紹介特典プランで表示（Stripe課金プランでは非表示）
        ...(!isPaidPlan || referralActive
            ? [
                  {
                      i: 'hmReferral',
                      x: 9,
                      y: 7,
                      w: 6,
                      h: 3,
                      minW: 3,
                      minH: 3,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
        // 広告は「無料（有料プランでない）」時のみ表示
        ...(!isPaidPlan
            ? [
                  {
                      i: 'hmAd',
                      x: 9,
                      y: 1,
                      w: 3,
                      h: 3,
                      minW: 3,
                      minH: 3,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
        { i: 'hmAppRegistIntro', x: 0, y: 10, w: 6, h: 3 },
        /**
         * 分析画面
         */
        {
            i: 'anSearch',
            x: 0,
            y: 0,
            w: 12,
            h: 2,
            minW: 3,
            minH: 1,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTotalTime',
            x: 0,
            y: 2,
            w: 3,
            h: 2,
            minW: 2,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anAverageTime',
            x: 3,
            y: 2,
            w: 3,
            h: 2,
            minW: 2,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTotalSchedule',
            x: 6,
            y: 2,
            w: 3,
            h: 2,
            minW: 2,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anRanking',
            x: 7,
            y: 4,
            w: 5,
            h: 3,
            minW: 3,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anChart',
            x: 0,
            y: 4,
            w: 7,
            h: 3,
            minW: 2,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTable',
            x: 0,
            y: 7,
            w: 12,
            h: 7,
            minW: 5,
            minH: 4,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        // 有料プランの場合は広告を非表示（紹介特典も有料扱いで非表示）
        ...(!isPaidPlan
            ? [
                  {
                      i: 'anAd',
                      x: 9,
                      y: 2,
                      w: 3,
                      h: 2,
                      minW: 2,
                      minH: 2,
                      static: true,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
    ],
    /**
     * タブレットレイアウト
     * 最大カラム数６
     */
    tablet: [
        // デスク画面
        { i: 'hmTimeClock', x: 0, y: 0, w: 6, h: 3, minW: 3, minH: 3 },
        { i: 'hmActivityCalendar', x: 0, y: 3, w: 6, h: 3, minW: 3, minH: 3 },
        { i: 'hmTimeProgress', x: 0, y: 6, w: 6, h: 3, minW: 3, minH: 3 },
        { i: 'hmSimpleAnalytics', x: 0, y: 9, w: 6, h: 3, minW: 3, minH: 3 },
        { i: 'hmMemo', x: 0, y: 12, w: 6, h: 9, minW: 3, minH: 3 },
        // 紹介パネルは無料プランと紹介特典プランで表示（Stripe課金プランでは非表示）
        ...(!isPaidPlan || referralActive
            ? [
                  {
                      i: 'hmReferral',
                      x: 0,
                      y: 21,
                      w: 6,
                      h: 2,
                      minW: 3,
                      minH: 2,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
        // 広告は「無料（有料プランでない）」時のみ表示
        ...(!isPaidPlan
            ? [
                  {
                      i: 'hmAd',
                      x: 0,
                      y: 23,
                      w: 6,
                      h: 3,
                      minW: 3,
                      minH: 3,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
        { i: 'hmAppRegistIntro', x: 0, y: 26, w: 6, h: 3 },
        // 分析画面
        {
            i: 'anSearch',
            x: 0,
            y: 0,
            w: 6,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTotalTime',
            x: 0,
            y: 2,
            w: 2,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anAverageTime',
            x: 2,
            y: 2,
            w: 2,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTotalSchedule',
            x: 4,
            y: 2,
            w: 2,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anRanking',
            x: 0,
            y: 8,
            w: 6,
            h: 3,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anChart',
            x: 0,
            y: 11,
            w: 6,
            h: 4,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTable',
            x: 0,
            y: 15,
            w: 6,
            h: 8,
            minW: 2,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        // 有料プランの場合は広告を非表示（紹介特典も有料扱いで非表示）
        ...(!isPaidPlan
            ? [
                  {
                      i: 'anAd',
                      x: 3,
                      y: 23,
                      w: 3,
                      h: 2,
                      minW: 2,
                      minH: 2,
                      static: true,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
    ],
    /**
     * モバイルレイアウト
     * 最大カラム数２
     */
    mobile: [
        // デスク画面
        { i: 'hmTimeClock', x: 0, y: 0, w: 2, h: 2, isDraggable: true, isResizable: true },
        { i: 'hmActivityCalendar', x: 0, y: 4, w: 2, h: 3, isDraggable: true, isResizable: true },
        { i: 'hmTimeProgress', x: 0, y: 2, w: 2, h: 2, isDraggable: true, isResizable: true },
        { i: 'hmSimpleAnalytics', x: 0, y: 7, w: 2, h: 3, isDraggable: true, isResizable: true },
        { i: 'hmMemo', x: 0, y: 10, w: 2, h: 3, isDraggable: true, isResizable: true },
        // 紹介パネルは無料プランと紹介特典プランで表示（Stripe課金プランでは非表示）
        ...(!isPaidPlan || referralActive
            ? [
                  {
                      i: 'hmReferral',
                      x: 0,
                      y: 13,
                      w: 2,
                      h: 4,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
        // 広告は「無料（有料プランでない）」時のみ表示
        ...(!isPaidPlan
            ? [
                  {
                      i: 'hmAd',
                      x: 0,
                      y: 17,
                      w: 2,
                      h: 3,
                      static: true,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
        {
            i: 'hmAppRegistIntro',
            x: 0,
            y: 20,
            w: 2,
            h: 3,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        // 分析画面
        {
            i: 'anSearch',
            x: 0,
            y: 0,
            w: 2,
            h: 4,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTotalTime',
            x: 0,
            y: 4,
            w: 2,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anAverageTime',
            x: 0,
            y: 6,
            w: 1,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTotalSchedule',
            x: 1,
            y: 6,
            w: 1,
            h: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anRanking',
            x: 0,
            y: 8,
            w: 2,
            h: 3,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anChart',
            x: 0,
            y: 11,
            w: 2,
            h: 3,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        {
            i: 'anTable',
            x: 0,
            y: 14,
            w: 2,
            h: 5,
            minW: 2,
            minH: 2,
            isDraggable: isPaidPlan,
            isResizable: isPaidPlan,
        },
        // 有料プランの場合は広告を非表示（紹介特典も有料扱いで非表示）
        ...(!isPaidPlan
            ? [
                  {
                      i: 'anAd',
                      x: 0,
                      y: 23,
                      w: 2,
                      h: 3,
                      minW: 2,
                      minH: 2,
                      static: true,
                      isDraggable: false,
                      isResizable: false,
                  },
              ]
            : []),
    ],
});
